const MinusPlusCircle01Icon = /*#__PURE__*/ [
  ["path", { d: "M12 16.5V10.1364M15.5 13.3182H8.5M15.5 7.5H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { MinusPlusCircle01Icon as default };
//# sourceMappingURL=MinusPlusCircle01Icon.js.map
